<template>
  <HeaderComp/>
  <div class="container">
    <div class="heading-wrapper">
      <img src="@/assets/brackets.svg" alt="" class="heading">
      <br>
      <svg width="301" height="21" viewBox="0 0 301 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 19C99.958 1.65814 200.005 1.66312 299.204 1.66312" stroke="#0092bc" stroke-width="3" stroke-linecap="round"/>
      </svg>
    </div>
    <br>
    <p>
      <br>
      Dia 25/10 – Ronda 1 (Melhor de 1) – 64 Jogador – 18:00h
      <br>
      Dia 25/10 – Ronda 2 (Melhor de 1) – 32 Jogador – 19:00h
      <br>
      Dia 26/10 – Ronda 3 (Melhor de 1) – 16 Jogador – 17:00h
      <br>
      Dia 30/10 – Quatros de final (Melhor de 3) –  8 Jogador – Presencial 12:00h (Arena Planta 1 - Plaza Central – Diagonal del mar)
      <br>
      Dia 30/10 – Semi-Final  (Melhor de 3) 4 Jogador – Presencial 12:30h (Arena Planta 1 - Plaza Central – Diagonal del mar)
      <br>
      Dia 30 – Final Round (Melhor de 3) – 2 Jogador – Presencial 13:00 (Arena Planta 1 - Plaza Central – Diagonal del mar)
    </p>
    <Rounds/>
    <div class="buttons">
        <h1 style="text-align: center">Jogar na PS4</h1>
        <p>
          <br>
          Manual para criação de partida e convite do rival:+
          <br>
          1. Acede ao canal correspondente no <a href="https://discord.com/invite/RBQdEGvwfC" class="bracket-link" target="_blank">Discord</a> (Partida "ID")
          <br>
          2. Adiciona o teu rival como amigo na PlayStation.
          <br>
          3. Dentro do jogo, vai ao menu "Amigáveis" na seção FIFA Ultimate Team.
          <br>
          4. Escolhe o modo Classic Match
          <br>
          5. Convida o teu rival da tua lista de amigos
          <br>
          6. Configura o jogo.
          <br>
          7. Inicia o jogo.
      </p>
    </div>

    <div>
      <h1 style="text-align: center">Resultados</h1>
      <p>
        Ao final de cada partida, os jogadores são responsáveis por capturar a tela de resultados e reportá-la.
        <br>
        Para criar um ticket com os RESULTADOS, clique no botão "Relatar Resultado" 📩 no <a href="https://discord.gg/FEJmJM3Wxf" class="bracket-link" target="_blank">Discord</a>
        <br>
        Caso o tempo de apresentação do resultado seja ultrapassado, a administração deve ser notificada através do suporte.
        <br>
      </p>
    </div>
    <div class="buttons">
      <a href="https://discord.gg/FEJmJM3Wxf" class="bracket-link" target="_blank"><button>Play!</button></a>
    </div>
    <div class="wrapper">
      <div class="brackets">
        <img v-if="round === 'round1'" src="@/assets/round1.png" alt="" class="brackets-img">
        <!--<img v-if ="round === 'round2'" src="@/assets/round2.png" alt="" class="brackets-img">
        <img v-if ="round === 'round3'" src="@/assets/round3.png" alt="" class="brackets-img">-->
      </div>
    </div>
    <div class="buttons">
      <a href="https://discord.gg/FEJmJM3Wxf" class="bracket-link" target="_blank"><button>Apoio & Regras do jogo</button></a>
    </div>
  </div>
  <FooterComp/>
</template>

<script>
import HeaderComp from "../components/Header.vue";
import FooterComp from "@/components/Footer.vue";
import Rounds from "@/components/Rounds.vue";

export default {
    data(){
        return{
            tournament:'TOURNAMENT',
            round: this.$route.query.round || 'round1',
        }
    },
  components: { HeaderComp, FooterComp, Rounds }
}
</script>
<style lang="scss" scoped>
    .container{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 50px;
        .logo{
            width: 150px;
            margin-bottom: 35px;
        }
        h2{
            font-style: normal;
            font-weight: 700;
            font-size: 24px;
            line-height: 29px;
            text-align: center;
            color: #012A2D;
            margin-bottom: 35px;
        }
        p{
            font-weight: 400;
            font-size: 16px;
            line-height: 19px;
            text-align: center;
            color: #000000;
            margin-bottom: 35px;

        }
        button{
            width: 308px;
            height: 44px;
            background: #17E88F;
            border: none;
            transition: all .2s;
            cursor: pointer;
            font-weight: 700;
            font-size: 24px;
            line-height: 29px;
            color: #012A2D;
            margin-bottom: 40px;
            @media only screen and (max-width:740px){
                width: 270px;
            }
            &:active{
                transform: scale(0.95);
            }
            &:hover{
                box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.05);
            }
        }
        .footer{
            width: 100%;
        }
        .bg-hexa{
            position: absolute;
            left: 0;
            bottom: 300px;
            z-index: -1;
            width: 430px;
            @media only screen and (max-width:1140px){
                width: 250px;
                bottom: 200px;
            }
            @media only screen and (max-width:740px){
                width: 180px;
                bottom: 150px;
            }
        }
      .brackets{
        text-align: center;
        margin-bottom: 50px;
      }
      // Adapt img size to screen size
      .brackets-img{
        width: 100%;
        @media only screen and (max-width:740px){
          width: 90%;
        }
      }
    }

</style>